module.exports = __webpack_public_path__ + "static/media/38_tn.9f3c8f00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/38_tn.jpg
// module id = 251
// module chunks = 0